import React from 'react'

function Opticlean() {
  return (
    <embed src="\pdfs\E1.1.10.1_OC-Q_Opticlean_06.2013-1_kr.pdf" width="100%" height="2100px" />
  )
}

export default Opticlean